import * as React from 'react';
import { Styler, StylerProps } from '../../Styler/Styler';
import { DIALOG_STATIC_STYLES } from '../Dialog.styles';

export interface DialogContentProps extends StylerProps {
    /**
     * The content of the component.
     */
    children: React.ReactNode;

    /**
     * If `true`, the default left and right padding will not be applied.
     * @default false
     */
    disableGutters?: boolean;

    /**
     * Callback fired when the root element is scrolled.
     */
    onScroll?: () => void;
}

export function DialogContent(props: Readonly<DialogContentProps>): React.JSX.Element {
    const { children, disableGutters = false, ref, ...other } = props;

    return (
        <Styler
            ref={ref}
            baseStyles={DIALOG_STATIC_STYLES.content}
            data-dialog-content={true}
            data-default-gutters={!disableGutters || undefined}
            {...other}
        >
            {children}
        </Styler>
    );
}
